'use client';

import React from 'react';
import Link from 'next/link';
import { useLocaleLink } from '@/ui/hooks/useLocaleLink';
import { buildTrackingId } from '@/utils/tracking-helper';
import Container from '../../shared/Container';
import { BreadcrumbsTile } from './types/BreadcrumbsTile';

export default function Breadcrumbs({
  tile,
  trackingPrefix,
}: Readonly<{
  tile: BreadcrumbsTile;
  trackingPrefix?: string;
}>) {
  const { localizedLink } = useLocaleLink();
  const breadcrumbs = tile.pages.items;

  return (
    <Container>
      <div className="mx-auto flex w-fit">
        {breadcrumbs?.map((item, index: number) => {
          const pageName =
            item.nameComponent?.content?.__typename === 'SingleLineContent'
              ? item.nameComponent.content.text
              : '';
          if (item.path) {
            const breadcrumbTrackingId = buildTrackingId(trackingPrefix, pageName);
            return (
              <div key={item.path}>
                <Link
                  href={localizedLink(item.path)}
                  className=" text-xs uppercase hover:underline"
                  data-tile-element-id={breadcrumbTrackingId}
                >
                  {pageName}
                </Link>
                {index !== breadcrumbs.length - 1 && <span className="mx-2">•</span>}
              </div>
            );
          }
          return null;
        })}
      </div>
    </Container>
  );
}
